export class AuthenticationError extends Error {
  public errors: Record<string, string>;
  constructor(errors: Record<string, string>, message?: string) {
    super(message);

    this.errors = errors;
  }
}
